import { Pipe, PipeTransform } from "@angular/core";
import { Tools } from "@comunicare/comunicare-helper";

@Pipe({
  name: "i18nPeriodUnitKey",
})
export class I18nPeriodUnitKeyPipe implements PipeTransform {
  transform(value: string): string {
    return Tools.getI18nPeriodUnitKey(value?.toUpperCase()); // toUpperCase needed because the backend return "m" for month (for prescription / billing)
  }
}
